exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".whatsapp-container{\n    position: fixed;\n  bottom: 15px;\n  left: 15px;\n  /*border: 1px solid gray;*/\n  padding: 10px;\n  box-shadow: 0px 0px 17px -9px;\n  background-color: white;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  border-radius: 15px;\n  cursor: pointer;\n  z-index: 1000;\n}\n.whatsapp-container:hover{\n  box-shadow: 0px 0px 17px -5px;\n}\n\n.whatsapp-icon{\n  background-image: url(" + require("../../../assets/img/whatsapp.png") + ");\n  background-size: cover;\n  background-position: center;\n  width: 30px;\n  height: 30px;\n  /*margin-left: 8px;*/\n}\n\n.support-text{\n\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/component/whatsapp-support/whatsapp-support.component.css
// module id = 1096
// module chunks = 3